import { AutogenLayoutScoreCardReasonCodesMapping } from "./autogen/AutogenLayoutScoreCardReasonCodesMapping";
import {  TableRowDisplayEvent } from "@mcleod/components";

export class ScoreCardReasonCodesMapping extends AutogenLayoutScoreCardReasonCodesMapping {

/** This is an event handler for the onRowDisplay event of tableReasonCodesMapping. */
  tableReasonCodesMappingOnRowDisplay(event: TableRowDisplayEvent) {
       const tableRow = event.getTableRow();
        console.log(tableRow.mode);

  }
}
